import { useState } from "react";
import { getOtp } from "../services/guest";

export const useOtp = () => {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const sendOtp = async (phoneNumber: string) => {
    setError(null);
    setSuccess(false);
    try {
      const res = await getOtp(phoneNumber);

      if (res?.status === 200) {
        setSuccess(true);
      } else {
        setError("Failed to send OTP");
      }
    } catch (err: any) {
      setError(err?.message || "Something went wrong");
    } 
  };

  return {
    sendOtp,
    error,
    success,
  };
};
